import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  FamsAppRoleMe,
  FamsAppRoleMemberList,
  FamsPermissionItem,
  FamsRbacRole,
  FamsRbacRoleList,
} from './types/app-role';

const request = createAppRequest();

export async function getMyAppRoles(options?: ApiRequestOptions) {
  return request<FamsAppRoleMe>('/bff/fams/roles/me', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function getAppRolePermissions(options?: ApiRequestOptions) {
  return request<FamsPermissionItem[]>('/bff/fams/roles/permissions', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function getAppRoles(options?: ApiRequestOptions) {
  return request<FamsRbacRoleList>('/bff/fams/roles', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function createAppRole(
  payload: {
    code: string;
    name: string;
    description?: string;
    permissionCodes?: string[];
  },
  options?: ApiRequestOptions,
) {
  return request<FamsRbacRole>('/bff/fams/roles', {
    method: 'POST',
    data: payload,
    ...(options || {}),
  });
}

export async function updateAppRole(
  id: number,
  payload: {
    name?: string;
    description?: string;
    permissionCodes?: string[];
  },
  options?: ApiRequestOptions,
) {
  return request<FamsRbacRole>(`/bff/fams/roles/${id}`, {
    method: 'PUT',
    data: payload,
    ...(options || {}),
  });
}

export async function updateAppRolePermissions(
  id: number,
  permissionCodes: string[],
  options?: ApiRequestOptions,
) {
  return request<FamsRbacRole>(`/bff/fams/roles/${id}/permissions`, {
    method: 'PUT',
    data: { permissionCodes },
    ...(options || {}),
  });
}

export async function deleteAppRole(id: number, options?: ApiRequestOptions) {
  return request<FamsRbacRoleList>(`/bff/fams/roles/${id}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

export async function getAppRoleMembers(options?: ApiRequestOptions) {
  return request<FamsAppRoleMemberList>('/bff/fams/roles/members', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function updateAppRoleMember(
  userUuid: string,
  roleIds: number[],
  options?: ApiRequestOptions,
) {
  return request<FamsAppRoleMemberList>(
    `/bff/fams/roles/members/${encodeURIComponent(userUuid)}`,
    {
      method: 'PUT',
      data: { roleIds },
      ...(options || {}),
    },
  );
}
